module.exports = __webpack_public_path__ + "static/media/e_2.9763e1af.svg";